import { FormEvent } from "react";
import zoomInEnable from "../../../../assets/ecg-graph/zoom_in_enable.svg";
import zoomOutEnable from "../../../../assets/ecg-graph/zoom_out_enable.svg";
import { round } from "../../../../utils/sharedUtil";
import { Button } from "@shltelemedicine/shl-ui-lib";
import styles from "./Zoom.module.css";

type ZoomProps = {
  value?: number;
  min?: number;
  max?: number;
  step?: number;
  onChange?: (value: number) => void;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  disabled?: boolean;
};

const Zoom = ({
  value = 100,
  min = 100,
  max,
  step = 10,
  onChange,
  onZoomIn,
  onZoomOut,
  disabled,
}: ZoomProps) => {
  const zoomInHandler = () => {
    if (max && value >= max) return;
    if (onZoomIn) onZoomIn();
    if (onChange) onChange(max ? Math.min(value + step, max) : value + step);
  };

  const zoomOutHandler = () => {
    if (min && value <= min) return;
    if (onZoomOut) onZoomOut();
    if (onChange) onChange(min ? Math.min(value - step, min) : value - step);
  };

  const changeHandler = (event: FormEvent<HTMLInputElement>) => {
    if (onChange) onChange(+event.currentTarget.value);
  };

  let zoomValue = `${round(value, 0)}%`;
  if (max && value >= max) {
    zoomValue = `${round(max, 0)}%`;
  } else if (min && value <= min) {
    zoomValue = `${round(min, 0)}%`;
  }

  return (
    <div className="d-flex align-items-center">
      <Button
        disabled={disabled || (min ? value <= min : false)}
        variant=""
        onClick={zoomOutHandler}
        className={`${styles.button} p-0`}
      >
        <img src={zoomOutEnable} alt="" className={styles.buttonIcon} />
      </Button>
      <input
        type="text"
        disabled={disabled}
        value={zoomValue}
        onChange={changeHandler}
        className={`${styles.zoomInput} mx-1 py-0 font-md text-center`}
        readOnly
      />
      <Button
        disabled={disabled || (max ? value >= max : false)}
        variant=""
        onClick={zoomInHandler}
        className={`${styles.button} p-0`}
      >
        <img src={zoomInEnable} alt="" className={styles.buttonIcon} />
      </Button>
    </div>
  );
};

export default Zoom;
